module.exports = __webpack_public_path__ + "static/media/55_000089.be7fa251.jpg";